module.exports = "/static/fonts/OpenSans-Italic.woff";